module.exports = __webpack_public_path__ + "img/logo-lrg.9c6aa785.png";